import careConfig from "@careConfig";
import { useEffect, useState } from "react";

import Loading from "@/components/Common/Loading";
import { getKeycloakClaims } from "@/Integrations/Keycloak/keycloak";

import { resolveAppEntry } from "./appEntry";

/**
 * On the central app host the user is authenticated but has no tenant host yet.
 * Read `care_slug` from the token and hand the browser to that facility.
 * On every other host this is a transparent pass-through.
 */
export default function AppEntryGate({
  children,
}: {
  children: React.ReactNode;
}) {
  const [decision] = useState(() =>
    resolveAppEntry(
      window.location.hostname,
      getKeycloakClaims(),
      careConfig.appEntryHost,
      careConfig.baseDomain,
    ),
  );

  useEffect(() => {
    if (decision.kind === "redirect") {
      window.location.replace(decision.url);
    }
  }, [decision]);

  if (decision.kind === "pass") return <>{children}</>;

  if (decision.kind === "support") {
    return (
      <div className="flex min-h-[60vh] items-center justify-center p-8 text-center">
        <div>
          <h1 className="text-xl font-semibold">
            We couldn't find your facility
          </h1>
          <p className="mt-2 text-gray-600">
            Your account isn't linked to a facility yet. Contact{" "}
            <a
              className="text-primary-600 underline"
              href="mailto:info@welsys.co.ke"
            >
              info@welsys.co.ke
            </a>
            .
          </p>
        </div>
      </div>
    );
  }

  return <Loading />;
}
